import { render, staticRenderFns } from "./LoginAdditionalAction.vue?vue&type=template&id=b0ae8d70&scoped=true"
import script from "./LoginAdditionalAction.vue?vue&type=script&lang=js"
export * from "./LoginAdditionalAction.vue?vue&type=script&lang=js"
import style0 from "./LoginAdditionalAction.vue?vue&type=style&index=0&id=b0ae8d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ae8d70",
  null
  
)

export default component.exports